<template>
  <section v-if="!hideSupplier && (supplier || guide)">
    <SectionHeading icon="icon-multiple-users-1" title="Your local guide" />

    <template v-if="supplier">
      <img class="image" :src="supplier.image?.url ?? DefaultProfileImage" />
      <div class="description">{{ supplier.description }}</div>

      <SupplierRating v-if="supplier.rating" class="rating" :rating="supplier.rating" />

      <div v-if="supplier.supplierReviews && supplier.supplierReviews.length > 0" class="reviews">
        <SupplierReview v-for="(review, i) in supplier.supplierReviews" class="review" :review="review" :key="i" />
      </div>
    </template>

    <template v-else-if="guide">
      <img class="image" :src="guide.profileImage?.url ?? DefaultProfileImage" />
      <div class="description">{{ guide.description }}</div>
    </template>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useItineraryStore } from '@/stores/itinerary.js'
import SupplierRating from '@/modules/Itinerary/Components/SupplierRating.vue'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import SupplierReview from '@/modules/Itinerary/Components/SupplierReview.vue'
import DefaultProfileImage from 'app/assets/images/overlands/default_hero_profile.jpg'

const {
  data: {
    supplier,
    itinerary: { guides },
    hideSupplier,
  },
} = useItineraryStore()
const guide = computed(() => guides?.[0] ?? null)
</script>

<style lang="scss" scoped>
section {
  @include flex-column(20px);
}

.image {
  width: 100%;
  border-radius: 15px;
}

.reviews {
  margin-top: 4px;
  @include flex-column(12px);
}

.review {
  padding: 16px;
  border: 1px solid $grey-50;
  border-radius: 15px;
}
</style>
